import { useTranslation } from 'react-i18next'
import { SelectWrapper } from '../wrapper'
import Select from 'react-select'
import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { toOptions } from '@/utils'

export const ManagmentSelector = ({ onChange, value, required = false, isClearable = false }) => {
  const { t } = useTranslation()
  const [managments, setManagments] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedSubmanagment, setSelectedSubmanagment] = useState({})
  const [selectedManagment, setSelectedManagment] = useState({})
  const [subManagmentOptions, setSubManagmentOptions] = useState([])

  const getManagments = useCallback(async () => {
    setLoading(true)
    try {
      const { data: { managments = [] } = {} } = await axios.get('/api/v1/accounts/managments')
      const options = toOptions({ data: managments })
      setManagments(options)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [])

  const getSubmanagment = useCallback(async (id) => {
    try {
      const { data: subManagment = {} } = await axios.get(
        `/api/v1/accounts/managments?id=${id}`, { responseType: 'json' }
      )

      const newSelectedManagment = managments.find((managment) => managment.value === subManagment?.parent?.id)
      const newSelectedSubmanagment = newSelectedManagment.resource.subManagments.find((subManagment) => subManagment.id === id)

      setSelectedManagment(newSelectedManagment)
      setSelectedSubmanagment(toOptions({ data: [newSelectedSubmanagment] })[0])
      setSubManagmentOptions(toOptions({ data: newSelectedManagment.resource.subManagments }))
    } catch (e) {
      console.log(e)
    }
  }, [managments, value])

  useEffect(() => {
    if (!value) {
      setSelectedSubmanagment({})
    }
  }, [value])

  useEffect(() => {
    getManagments()
  }, [])

  useEffect(() => {
    if (!value) return
    if (!managments.length) return

    getSubmanagment(value)
  }, [getSubmanagment])

  const onManagmentChange = (option) => {
    if (!option) {
      setSelectedManagment({})
      setSelectedSubmanagment({})
      setSubManagmentOptions([])
      onChange(null)
      return
    }

    setSelectedManagment(option)
    setSelectedSubmanagment({})
    onChange(null)
    const subManagment = option?.resource?.subManagments || []
    const subManagmentOptions = toOptions({ data: subManagment })
    setSubManagmentOptions(subManagmentOptions)
  }

  const onSubmanagmentChange = (option) => {
    setSelectedSubmanagment(option || {})
    onChange(option)
  }

  return (
    <>

      <SelectWrapper label={t('managment.one')} required={required}>
        {(styles) => (

          <Select
            placeholder={t('select.one')}
            options={managments}
            isLoading={loading}
            isClearable={isClearable}
            loadingMessage={() => t('select.loading')}
            value={selectedManagment.value ? selectedManagment : null}
            styles={styles}
            menuPortalTarget={document.body}
            onChange={onManagmentChange}
          />
        )}
      </SelectWrapper>

      <SelectWrapper label={t('subManagment.one')} required={required}>
        {(styles) => (

          <Select
            placeholder={t('select.one')}
            isDisabled={!selectedManagment?.value}
            isClearable={isClearable}
            options={subManagmentOptions}
            loadingMessage={() => t('select.loading')}
            value={selectedSubmanagment.value ? selectedSubmanagment : null}
            styles={styles}
            menuPortalTarget={document.body}
            onChange={onSubmanagmentChange}
          />
        )}
      </SelectWrapper >

    </>
  )
}

ManagmentSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
  isClearable: PropTypes.bool
}
